import { __assign } from "tslib";
import axios from 'axios';
var DEFAULT_BASE_URL = "https://www.wix.com";
export var SEARCH_EXPERIMENTAL_PARAM_NAME = 'searchExperimental';
function trimTrailingSlash(url) {
    return url.replace(/\/$/, '');
}
var SearchApi = /** @class */ (function () {
    function SearchApi(config) {
        this.experimental = config.experimental || false;
        this.axios = axios.create({
            baseURL: trimTrailingSlash(config.baseURL || DEFAULT_BASE_URL) + "/search-services-reader",
            headers: {
                Authorization: config.token,
            },
        });
    }
    SearchApi.getDocumentTypesUrl = function () {
        return '/v1/search/sources';
    };
    SearchApi.getSearchUrl = function () {
        return '/v1/search';
    };
    SearchApi.getSuggestionsUrl = function () {
        return '/v1/suggest';
    };
    SearchApi.getSampleUrl = function () {
        return '/v1/search/sample';
    };
    SearchApi.prototype.setToken = function (token) {
        this.axios.defaults.headers.common.Authorization = token;
    };
    SearchApi.prototype.getInstance = function () {
        return this.axios;
    };
    SearchApi.prototype.getExperimentalConfig = function () {
        var _a;
        return this.experimental
            ? (_a = {},
                _a[SEARCH_EXPERIMENTAL_PARAM_NAME] = true,
                _a) : {};
    };
    SearchApi.prototype.getDocumentTypes = function () {
        return this.axios.get(SearchApi.getDocumentTypesUrl(), {
            params: this.getExperimentalConfig(),
        });
    };
    SearchApi.prototype.search = function (searchRequest) {
        return this.axios.post(SearchApi.getSearchUrl(), __assign(__assign({}, searchRequest), this.getExperimentalConfig()));
    };
    SearchApi.prototype.getSuggestions = function (suggestionsRequest) {
        return this.axios.post(SearchApi.getSuggestionsUrl(), suggestionsRequest);
    };
    SearchApi.prototype.getSample = function (sampleRequest) {
        return this.axios.post(SearchApi.getSampleUrl(), __assign(__assign({}, sampleRequest), this.getExperimentalConfig()));
    };
    return SearchApi;
}());
export { SearchApi };
//# sourceMappingURL=api.js.map